import React from 'react';

import Hero from './sections/Hero/Hero';
import Story from './sections/Story/Story';
import Trust from './sections/Trust/Trust';
import People from './sections/People/People';
import Start from './sections/Start/Start';

/**
 * Coded body for the Console page at /p/about.
 * The hosted page still supplies the route, title, and app shell.
 */
const AboutPage = () => (
  <>
    <Hero />
    <Story />
    <Trust />
    <People />
    <Start />
  </>
);

export default AboutPage;
